import { makeAutoObservable } from "mobx";

export default class EvaluationStore {
    constructor() {
        makeAutoObservable(this);
    }

    evaluationInstances = [];
    currentInstance = null;

    setInstances = (instances) => {
        this.evaluationInstances = instances || [];
    };

    setCurrentInstance = (instance) => {
        this.currentInstance = instance;
    };

    clearCurrentInstance = () => {
        this.currentInstance = null;
    };

    evaluationStats = null;
    
    setEvaluationStats = (stats) => {
        this.evaluationStats = stats;
    };
    
    clearEvaluationStats = () => {
        this.evaluationStats = null;
    };
} 